import type { Telemetry } from "../../shared/api";

// A beacon outlives the page and never delays the person using it.
export function report(event: Telemetry) {
  navigator.sendBeacon("/api/telemetry", JSON.stringify(event));
}

// Each distinct error is reported once per page, and ten at most.
const reported = new Set<string>();
function reportError(message: string, source?: string) {
  if (reported.size >= 10 || reported.has(message)) return;
  reported.add(message);
  report({ kind: "error", message: message.slice(0, 300), source });
}
export function reportErrors() {
  addEventListener("error", (event) =>
    reportError(
      event.message,
      event.filename
        ? new URL(event.filename).pathname.slice(0, 200)
        : undefined,
    ),
  );
  addEventListener("unhandledrejection", (event) =>
    reportError(
      event.reason instanceof Error
        ? event.reason.message
        : String(event.reason),
    ),
  );
}

const transports = ["host", "srflx", "prflx", "relay"] as const;
// The local side of the selected candidate pair; relay means TURN carried the call.
export async function selectedTransport(peer: RTCPeerConnection) {
  const stats = await peer.getStats();
  for (const entry of stats.values()) {
    if (entry.type !== "transport" || !entry.selectedCandidatePairId) continue;
    const pair = stats.get(entry.selectedCandidatePairId);
    const type = stats.get(pair?.localCandidateId)?.candidateType;
    return transports.find((transport) => transport === type);
  }
}
